import { useContext } from "react";

import { CommandPaletteContext } from "./components/command-palette";

export const useCommandPaletteContext = () => {
  const context = useContext(CommandPaletteContext);

  if (!context) {
    throw new Error(
      "useCommandPaletteContext can only be used inside CommandPalette",
    );
  }

  return context;
};
